module.exports = __webpack_public_path__ + "img/facebook.f429c8a0.svg";